import { ComponentType, lazy, LazyExoticComponent } from 'react';
import { Application } from '@monorepo/types';
import { CountryCodeType, IconsMap } from './icons-map';

const FiversIcon = lazy(() => import('./icons/5ers-country.svg?react'));
const TtpIcon = lazy(() => import('./icons/ttp-country.svg?react'));

const isIconExists = (code: string) => {
  return Object.keys(IconsMap).includes(code.toUpperCase() as CountryCodeType);
};

const EXCEPTIONS_COUNTRY_MAP: Partial<
  Record<CountryCodeType, CountryCodeType>
> = {
  NC: 'FR',
};

export const getIconData = ({
  code,
  project = Application.THE5ERS,
}: {
  code: string;
  project?: Application;
}): {
  Icon: LazyExoticComponent<ComponentType>;
  code: string;
} => {
  code = EXCEPTIONS_COUNTRY_MAP[code as CountryCodeType] || code;

  let Icon = project === Application.TTP ? TtpIcon : FiversIcon;

  if (code && isIconExists(code)) {
    Icon = IconsMap[code as CountryCodeType];
  }

  return { Icon, code };
};

export const isValidCountryCode = (code?: string): code is CountryCodeType => {
  return !!code && code.toUpperCase() in IconsMap;
};

export const getCountryCode = (code?: string): CountryCodeType | undefined => {
  if (!code) return undefined;
  const upperCode = code.toUpperCase();
  return isValidCountryCode(upperCode) ? upperCode : undefined;
};
